import React, { useState, useEffect, useRef } from 'react';
import Basic from '../Components/Basic/Basic';
import Rightside from './Customer/Rightside.js';
import moment from 'moment';

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Crypto = ({ accountSlug: propAccountSlug }) => {
  const systemToken = localStorage.getItem('systemToken') || "";
  
  // Account slug for determining colors (from props, URL params, or default)
  // You can get this from URL params: const { slug } = useParams(); (if using React Router)
  // Or from localStorage: window.localStorage.getItem('active_page')
  const getAccountSlugFromStorage = () => {
    return window.localStorage.getItem('active_page') || 'crypto';
  };
  
  // Force crypto for this component - you can make this dynamic later
  const accountSlug = propAccountSlug || 'crypto';
  
  // Debug: log what accountSlug is being used
  console.log('Current accountSlug:', accountSlug);
  
  // Color mapping based on account slug (using your actual CSS classes)
  const getAccountColors = (slug) => {
    const colorMap = {
      'paymaster': {
        gradient: 'bg-purple-gradient',
        tailwindGradient: 'from-purple-600 to-pink-200',
        bgClass: 'bg-purple-gradient',
        color: '#7957F5',
        colorName: 'purple',
        textColor: 'text-white',
        isDark: false
      },
      'fum': {
        gradient: 'bg-yellow-gradient', 
        tailwindGradient: 'from-orange-400 to-yellow-500',
        bgClass: 'bg-yellow-gradient',
        color: '#fdad41',
        colorName: 'orange',
        textColor: 'text-white',
        isDark: false
      },
      'securities': {
        gradient: 'bg-black-gradient',
        tailwindGradient: 'from-gray-600 to-gray-700',
        bgClass: 'bg-black-gradient',
        color: '#494949',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      },
      'property': {
        gradient: 'bg-brown-gradient',
        tailwindGradient: 'from-amber-700 to-amber-800',
        bgClass: 'bg-brown-gradient',
        color: '#ad8e8e',
        colorName: 'brown',
        textColor: 'text-white',
        isDark: false
      },
      'commodities': {
        gradient: 'bg-blue-gradient',
        tailwindGradient: 'from-blue-400 to-blue-500',
        bgClass: 'bg-blue-gradient',
        color: '#33bfff',
        colorName: 'blue',
        textColor: 'text-white',
        isDark: false
      },
      'custodian': {
        gradient: 'bg-dark-gradient',
        tailwindGradient: 'from-gray-900 to-black',
        bgClass: 'bg-dark-gradient',
        color: '#0a0909',
        colorName: 'dark',
        textColor: 'text-white',
        isDark: true
      },
      'my-investment': {
        gradient: 'bg-green-gradient',
        tailwindGradient: 'from-green-500 to-green-400',
        bgClass: 'bg-green-gradient',
        color: '#22b931',
        colorName: 'green',
        textColor: 'text-white',
        isDark: false
      },
      'crypto': {
        gradient: 'bg-crypto',
        tailwindGradient: 'from-indigo-900 to-indigo-950',
        bgClass: 'bg-crypto',
        color: '#08003b',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      },
      'private-wealth': {
        gradient: 'bg-crypto',
        tailwindGradient: 'from-indigo-900 to-indigo-950',
        bgClass: 'bg-crypto',
        color: '#08003b',
        colorName: 'black',
        textColor: 'text-white',
        isDark: true
      }
    };
    
    return colorMap[slug] || colorMap['crypto']; // Default to crypto colors
  };
  
  const accountColors = getAccountColors(accountSlug);
  
  // State variables
  const [userName, setUserName] = useState('');
  const [userInfo, setUserInfo] = useState({
    user_name: '',
    join_date: '',
    default_currency: 'AUD',
    default_currency_icon: '$'
  });
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [totalAcBalance, setTotalAcBalance] = useState(0);
  const [totalActiveDefaultBalance, setTotalActiveDefaultBalance] = useState(0);
  const [totalArchiveDefaultBalance, setTotalArchiveDefaultBalance] = useState(0);
  const [defaultCurrencyIcon, setDefaultCurrencyIcon] = useState('$');
  const [defaultCurrency, setDefaultCurrency] = useState('AUD');
  const [subac, setSubac] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [activeSubac, setActiveSubac] = useState('');
  const [localStorageData, setLocalStorageData] = useState({});
  const [crypto, setCrypto] = useState({
    ac_balance: 0,
    default_currency_balance: 0,
    userac_name: 'Digital Assets',
    userac_reference_code: '#',
    userac_establish_date: ''
  });

  // Chart state variables
  const [last12Months] = useState([
    moment().subtract(11, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(10, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(9, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(8, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(7, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(6, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
    moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
  ]);
  const [activeChart, setActiveChart] = useState(1);
  const [onChart, setOnChart] = useState(0);
  // const [chart1, setChart1] = useState([0, 0, 0, 0]);
  // const [chart2, setChart2] = useState([0, 0, 0]);
  // const [chart3, setChart3] = useState([0, 0, 0, 0, 0, 0]);
  // const [chart4, setChart4] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  // const [chart5, setChart5] = useState([0, 0]);

  
  const [chart1, setChart1] = useState([1000, 2000, 1500, 3000]);
  const [chart2, setChart2] = useState([2500, 3000, 3500]);
  const [chart3, setChart3] = useState([4000, 4500, 5000, 5500, 6000, 6500]);
  const [chart4, setChart4] = useState([7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12500]);
  const [chart5, setChart5] = useState([13000, 13500]);


  const STORAGE_KEY = "caprock-local";

  // Chart options
  const chartOptions1 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#7957f5',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#7957f5'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  }; 

  const chartOptions2 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#7957f5',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#7957f5'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions3 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#7957f5',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#7957f5'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions4 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#7957f5',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: last12Months
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#7957f5'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions5 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#7957f5',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        "0000", "0000"
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#7957f5'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  // API functions
  // const get_user_accounts = async () => {
  //   try {
  //     const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
  //     // console.log('Getting user accounts from:', `${Base_url}/user-accounts`);
  //     const formData = new FormData(); 
  //     formData.append('user_token', systemToken); 
  //     const response = await fetch(`${Base_url}/user-accounts`, {
  //       method: 'POST', 
  //       body: formData
  //     });
      
  //     console.log('User accounts response status:', response.status);
      
  //     if (response.ok) {
  //       const data = await response.json();
  //       // const data = response
  //       console.log('User accounts data:', data, "Resposne is",response);
  //       if (data.success === 200) {
  //         setTotalAcBalance(data.t_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  //         setTotalActiveDefaultBalance(0);
  //         setTotalArchiveDefaultBalance(0);
          
  //         const acData = data.accounts;
  //         let totalActive = 0;
  //         let totalArchive = 0;
          
  //         for (let i = 0; i < acData.length; i++) {
  //           if (acData[i].userac_status === 1) {
  //             totalActive += acData[i].default_currency_balance;
  //           } else {
  //             totalArchive += acData[i].default_currency_balance;
  //           }
  //         }
          
  //         setTotalActiveDefaultBalance(totalActive);
  //         setTotalArchiveDefaultBalance(totalArchive);
          
  //         // Calculate percentages
  //         const accountsWithPercent = acData.map(account => ({
  //           ...account,
  //           ac_percent: (100 * account.default_currency_balance / totalActive)
  //         }));
          
  //         setCustomerAccounts(accountsWithPercent);
  //       }
  //     } else {
  //       console.error('User accounts response not ok:', response.status, response.statusText);
  //       // Set default values if API fails
  //       setCustomerAccounts([
  //         {
  //           userac_id: 1,
  //           ac_name: 'Digital Assets',
  //           ac_slug: 'crypto',
  //           ac_balance: 10000,
  //           default_currency_balance: 10000,
  //           userac_status: 1,
  //           ac_percent: 100
  //         }
  //       ]);
  //       setTotalAcBalance('10,000.00');
  //       setTotalActiveDefaultBalance(10000);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching user accounts:', error);
  //     // Set default values if API fails
  //     setCustomerAccounts([
  //       {
  //         userac_id: 1,
  //         ac_name: 'Digital Assets',
  //         ac_slug: 'crypto',
  //         ac_balance: 10000,
  //         default_currency_balance: 10000,
  //         userac_status: 1,
  //         ac_percent: 100
  //       }
  //     ]);
  //     setTotalAcBalance('10,000.00');
  //     setTotalActiveDefaultBalance(10000);
  //   }
  // };

  const get_user_info = async () => {
    try {
      const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
      const formData = new FormData();
      formData.append('user_token', systemToken);
      const response = await fetch(`${Base_url}/profile`, {
        method: 'POST', 
        body: formData
      });
       
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.success === 200) {
          const userInf = data.profile;
          userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
          setUserInfo(userInf);
          setDefaultCurrency(userInf.default_currency);
          setDefaultCurrencyIcon(userInf.default_currency_icon);
        }
      } else {
        
        // Set default values if API fails
        setUserInfo({
          user_name: '',
          join_date: '',
          default_currency: 'AUD',
          default_currency_icon: '$'
        });
        setDefaultCurrency('AUD');
        setDefaultCurrencyIcon('$');
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
      // Set default values if API fails
      setUserInfo({
        user_name: 'Demo User',
        join_date: '01 Jan, 2024',
        default_currency: 'AUD',
        default_currency_icon: '$'
      });
      setDefaultCurrency('AUD');
      setDefaultCurrencyIcon('$');
    }
  };

  const get_account_detail = async (ac_name) => {
    try {
      const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
      
      
      
      const formData = new FormData(); 
      formData.append('user_token', systemToken); 
      formData.append('ac_name', ac_name || accountSlug); // Use dynamic account slug
      // account_name: ac_name
      const response = await fetch(`${Base_url}/customer-account`, {
        method: 'POST',
        
        body: formData
      });
      
      
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.success === 200) {
          const cryptoData = data.ac_info;
          cryptoData.userac_establish_date = moment(cryptoData.userac_establish_date).format('DD MMM, YYYY');
          setCrypto(cryptoData);
          
          
          setSubac(data.ac_data.subaccounts);
          
          // Set active subaccount
          const subII = window.localStorage.getItem('crypto_subac_id');
          
          let subId = '';
          if (subII && subII > 0) {
            subId = subII;
          } else {
            subId = data.ac_data.subaccounts[data.ac_data.subaccounts.length - 1].subac_id;
          }
          setActiveSubac(subId);
          get_crypto_transactions(subId);
          
          // Process chart data
          const chartInfo = data.chart_data;
          if (data.chart_data.length>0){
            setChart1(data.chart_data.last_month_chart);
            setChart2(data.chart_data.three_month_chart);
            setChart3(data.chart_data.six_month_chart);
            setChart4(data.chart_data.year_chart.reverse());
          }
          
          // Process all time chart
          
          const allChart = chartInfo.all_chart;
          const newChart5 = [];
          const labels = [];
          
          if (allChart && allChart.length === 1) {
            newChart5.push(0);
            labels.push((allChart[0].year - 1));
          }
          if (allChart && allChart.length > 0) {
          for (let i = 0; i < allChart.length; i++) {
              newChart5.push(allChart[i].balance);
              labels.push(allChart[i].year);
            }
          }
          
          setChart5(newChart5);
          setOnChart(1);
        }
      } else {
        
        // Set default values if API fails
        setCrypto({
          ac_balance: 0,
          default_currency_balance: 0,
          userac_name: 'Digital Assets',
          userac_reference_code: '-',
          userac_establish_date: '--'
        });
        setSubac([]);
        setActiveSubac(1);
        setOnChart(1);
      }
    } catch (error) {
      console.error('Error fetching account detail:', error);  
    }
  };

  const get_crypto_transactions = async (subac_id) => {
    if (subac_id && subac_id > 0) {
      try {
        window.localStorage.setItem('crypto_fee_subac_id', subac_id);
        setActiveSubac(subac_id);
        const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
        
        
        const formData = new FormData(); 
        formData.append('user_token', systemToken); 
        formData.append('subac_id', subac_id); 
        const response = await fetch(`${Base_url}/crypto-transactions`, {
          method: 'POST', 
          body: formData
        });

        // const response = await fetch(`${Base_url}api/crypto-transactions`, {
        //   method: 'POST',
        //   headers: {
        //     'Authorization': `Bearer ${localStorageData['access-token']}`,
        //     'Content-Type': 'application/json'
        //   },
        //   body: JSON.stringify({
        //     token: localStorageData['access-token'],
        //     subac_id: subac_id
        //   })
        // });
        
        
        
        if (response.ok) {
          const data = await response.json();
          
          if (data.success === 200) {
            const transactions = data.transactions;
            
            // Format transaction dates
            const formattedTransactions = transactions.map(trans => ({
              ...trans,
              t_time: moment(trans.trans_date).format('DD MMM, YYYY')
            }));
            
            setTransactions(formattedTransactions);
          }
        } else {
          
          // Set default values if API fails
          setTransactions([
              
          ]);
        }
      } catch (error) {
        console.error('Error fetching crypto transactions:', error);
        // Set default values if API fails
        setTransactions([
          
        ]);
      }
    }
  };

  // Event handlers
  const filterTrans = (event) => {
    const subac_id = event.target.value;
    if (typeof subac_id !== "undefined" && subac_id > 0) {
      window.localStorage.setItem('crypto_subac_id', subac_id);
      setActiveSubac(subac_id);
      get_crypto_transactions(subac_id);
    }
  };

  // Lifecycle methods
  useEffect(() => {
    
    const js = JSON.parse((window.localStorage.getItem(STORAGE_KEY) || "{}"));
    
    if (typeof js !== 'undefined' && typeof js['access-token'] !== 'undefined') {
    
      setLocalStorageData(js);
    } else {
    
      window.localStorage.removeItem(STORAGE_KEY);
      // Redirect to sign-in (implement navigation logic)
      console.log('Redirect to sign-in');
    }
    
    document.title = `Digital Assets || Caprock Merchant Platform`;
    window.localStorage.setItem('active_page', accountSlug);
  }, []);

  useEffect(() => {
    
    // if (localStorageData['access-token']) {
    
      setUserName('');
      // get_user_accounts();
      get_user_info();
      get_account_detail(accountSlug);
    // } else {
    //   console.log('No token found in localStorageData');
    // }
  }, [localStorageData]);

  return (
    <>
      <Basic />
      {/* <Rightside user_info={userInfo} customer_accounts={customerAccounts} /> */}

      <div className="w-full p-5 box-border mt-5 overflow-x-hidden">
        <section className="w-full">
          {/* Top Row - Account Details & Transactions */}
          <div className="flex flex-wrap gap-4 mb-6 w-full">
            {/* Top Left - Account Details */}
            <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
              <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white`} style={{ minHeight: '300px' }}>
                <div className="flex flex-wrap -mx-4">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Type</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {accountSlug.charAt(0).toUpperCase() + accountSlug.slice(1).replace('-', ' ')}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Balance</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {defaultCurrency} {defaultCurrencyIcon} {crypto.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </h5>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mt-3">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Name</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {crypto.userac_name}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4 overflow-y-auto" style={{ maxHeight: '125px' }}>
                    {subac.map((subac_item) => (
                      <h5 key={subac_item.subac_id} className="text-white text-xs mt-2">
                        {subac_item.subac_name}<br />
                        {subac_item.currency_name} {subac_item.currency_symbol}{subac_item.subac_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </h5>
                    ))}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-4 mt-3">
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Account Reference</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      #{crypto.userac_reference_code}
                    </h5>
                  </div>
                  <div className="w-1/2 px-4">
                    <h5 className="text-white text-sm font-medium mt-1">
                      <b>Date Account Established</b>
                    </h5>
                    <h5 className="text-white text-xs mt-2">
                      {crypto.userac_establish_date}
                    </h5>
                  </div>
                </div>
              </div>
            </div>

            {/* Top Right - Transactions */}
            <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
              <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg`} style={{ minHeight: '300px' }}>
                {/* Transaction Header */}
                <div className={`flex justify-between items-center py-6 pl-8 pr-6 border-b ${accountColors.isDark ? 'border-white/20' : 'border-black/20'}`}>
                  <div className="flex items-center space-x-3">
                    <i className="fas fa-exchange-alt text-orange-400 text-xl"></i>
                    <div>
                      <h3 className={`text-lg font-bold ${accountColors.textColor}`}>Transactions</h3>
                      <p className={`text-sm ${accountColors.textColor} ${accountColors.isDark ? 'opacity-70' : 'opacity-80'}`}>View your cryptocurrency transaction history</p>
                    </div>
                  </div>
                  <div className="min-w-0 flex-1 max-w-xs ml-4">
                    <label className={`block text-xs ${accountColors.textColor} ${accountColors.isDark ? 'opacity-80' : 'opacity-90'} mb-2`}>Select Currency</label>
                    <select 
                      className={`w-full ${accountColors.isDark ? 'bg-white/10 border-white/20 text-white' : 'bg-black/10 border-black/20 text-black'} rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 ${accountColors.isDark ? 'focus:ring-white/30' : 'focus:ring-black/30'}`}
                      id="selected_subac_id" 
                      onChange={filterTrans}
                      value={activeSubac}
                    >
                      <option key="sj" value={0} className="text-gray-900">SELECT SUB ACCOUNT</option>
                      {subac.map((subac_item) => (
                        <option
                          key={subac_item.subac_id} 
                          value={subac_item.subac_id}
                          className="text-gray-900"
                        >
                          {subac_item.subac_name} ({subac_item.currency_name})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                {/* Transaction Table Headers */}
                <div className={`py-4 pl-8 pr-6 border-b ${accountColors.isDark ? 'border-white/20' : 'border-black/20'}`}>
                  <div className={`grid grid-cols-12 gap-4 ${accountColors.textColor} font-semibold text-sm`}>
                    <div className="col-span-4">Transaction Details</div>
                    <div className="col-span-2 text-center">Debit</div>
                    <div className="col-span-2 text-center">Credit</div>
                    <div className="col-span-4 text-center">Running Balance</div>
                  </div>
                </div>
                
                {/* Transaction List */}
                <div className="pl-8 pr-6 max-h-96 overflow-y-auto">
                  {transactions.map((trans) => (
                    <div 
                      key={trans.trans_id} 
                      data-transId={trans.trans_id} 
                      id={`trans_${trans.trans_id}`} 
                      className="py-4 border-b border-white/10 last:border-b-0 hover:bg-white/5 transition-colors"
                    >
                      <div className="grid grid-cols-12 gap-4 items-center">
                        <div className="col-span-4">
                          <div className="flex items-center space-x-3">
                            <span className="bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase">
                              {trans.currency_name}
                            </span>
                            <div>
                              <div className="text-orange-400 font-bold text-sm">
                                +{trans.currency_symbol}{trans.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </div>
                              <div className="text-white/70 text-xs">
                                rate {trans.trans_usd_rate.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 10 })}
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-span-2 text-center">
                          {trans.trans_type === 1 && (
                            <span className="text-red-400 font-bold text-sm">
                              -{trans.subac_currency_symbol} {trans.trans_currency_total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </span>
                          )}
                        </div>
                        
                        <div className="col-span-2 text-center">
                          {trans.trans_type === 2 && (
                            <span className="text-green-400 font-bold text-sm">
                              +{trans.subac_currency_symbol} {trans.trans_currency_total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </span>
                          )}
                        </div>
                        
                        <div className="col-span-4 text-center">
                          <span className="text-white font-bold text-sm">
                            {trans.subac_currency_symbol} {trans.trans_subac_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                      </div>
                       
                      <div className="mt-3">
                        <div className="flex items-center space-x-2 flex-wrap">
                          <span className="text-orange-400 font-bold text-sm">
                            {trans.trans_type === 1 
                              ? (trans.trans_from_user_id > 0 ? `Transfer to ${trans.subac_name}` : 'Transfer')
                              : (trans.trans_from_user_id > 0 ? `Deposit from ${trans.user_name}` : 'Deposit')
                            }
                          </span>
                          <span className="bg-indigo-500 text-white text-xs px-2 py-1 rounded">
                            {trans.trans_type === 1 ? 'Transfer' : 'Deposit'}
                          </span>
                        </div>
                        <p className="text-white/70 text-xs mt-1">{trans.trans_description}</p>
                        <div className="flex items-center space-x-4 mt-1 text-xs text-white/60">
                          <span>{trans.t_time}</span>
                          <span>Transaction ref#{trans.trans_reference_no}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {!transactions.length && (
                  <div className="px-6 py-8 text-center">
                    <p className="text-white/70">No Transactions Found</p>
                  </div>
                )}
              </div>

            </div>
          </div>

           Bottom Row - Portfolio and Chart
          <div className="flex flex-wrap gap-4 w-full">
             
            <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
              {/*<div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white`} style={{ minHeight: '300px' }}>
                <h3 className="text-lg font-bold mb-6">Portfolio</h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center py-2">
                    <span className="text-sm">Cash Account</span>
                    <span className="text-sm">0%, $0.00</span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-sm">Fund Management</span>
                    <span className="text-sm">0%, $0.00</span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-sm">Trading Account</span>
                    <span className="text-sm">0%, $0.00</span>
                  </div>
                  <div className="flex justify-between items-center py-2">
                    <span className="text-sm">Digital Assets</span>
                    <span className="text-sm">100%, {defaultCurrency} {defaultCurrencyIcon} {crypto.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                  <hr className="border-white/20 my-4" />
                  <div className="flex justify-between items-center py-2">
                    <span className="text-sm font-bold">Total</span>
                    <span className="text-sm font-bold">{defaultCurrency} {defaultCurrencyIcon} {crypto.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                </div>app_bank_accounts
              </div> */}
            </div>

           
            <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
              <div className="bg-white rounded-xl overflow-hidden h-full">
                
                <div className="border-b border-gray-200 px-6 py-4">
                  <div className="flex space-x-8">
                    <button 
                      onClick={() => setActiveChart(1)} 
                      className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                        activeChart === 1 
                          ? 'text-blue-500 border-blue-500' 
                          : 'text-gray-500 border-transparent hover:text-gray-700'
                      }`}
                    >
                      Last Month
                    </button>
                    <button 
                      onClick={() => setActiveChart(2)} 
                      className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                        activeChart === 2 
                          ? 'text-blue-500 border-blue-500' 
                          : 'text-gray-500 border-transparent hover:text-gray-700'
                      }`}
                    >
                      3M
                    </button>
                    <button 
                      onClick={() => setActiveChart(3)} 
                      className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                        activeChart === 3 
                          ? 'text-blue-500 border-blue-500' 
                          : 'text-gray-500 border-transparent hover:text-gray-700'
                      }`}
                    >
                      6M
                    </button>
                    <button 
                      onClick={() => setActiveChart(4)} 
                      className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                        activeChart === 4 
                          ? 'text-blue-500 border-blue-500' 
                          : 'text-gray-500 border-transparent hover:text-gray-700'
                      }`}
                    >
                      Year
                    </button>
                    <button 
                      onClick={() => setActiveChart(5)} 
                      className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                        activeChart === 5 
                          ? 'text-blue-500 border-blue-500' 
                          : 'text-gray-500 border-transparent hover:text-gray-700'
                      }`}
                    >
                      All
                    </button>
                  </div>
                </div>

                
                <div className="p-6">
                  {onChart === 1 ? (
                    <div className="h-70 flex items-center justify-center">
                        {activeChart === 1 && <Line data={{ labels: ["Week 1", "Week 2", "Week 3", "Week 4"], datasets: [{ label: 'Balance', data: chart1, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions1} />}
                                {activeChart === 2 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3"], datasets: [{ label: 'Balance', data: chart2, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions2} />}
                                {activeChart === 3 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6"], datasets: [{ label: 'Balance', data: chart3, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions3} />}
                                {activeChart === 4 && <Line data={{ labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], datasets: [{ label: 'Balance', data: chart4, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions4} />}
                                {activeChart === 5 && <Line data={{ labels: ["Year 1", "Year 2"], datasets: [{ label: 'Balance', data: chart5, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions5} />}      
                   
                    </div>
                  ) : (
                    <div className="h-64 flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                      <span className="text-gray-500">Loading...</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Crypto;
